import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, reactive, defineAsyncComponent } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleEditor',
  setup(__props) {

let Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const state = reactive({
    content: '<p>As a <strong>web designer</strong>, your role is crucial in creating visually appealing and user-friendly websites. You are responsible for designing the layout, selecting color schemes, and creating an intuitive user interface. You work closely with clients to understand their requirements and translate them into stunning website designs. Your expertise lies in using HTML, CSS, and JavaScript to bring these designs to life. You pay attention to detail, ensuring that every element is pixel-perfect and responsive across different devices.</p> <ol><li>Artist</li><li>Developer</li><li>Musician</li></ol> <ul><li>Web-designer</li><li>UI-UX designer</li><li>Software engineer</li></ul>',
    _content: '',
    editorOption: {
        placeholder: 'core',
    },
    disabled: false
})
const onEditorChange = (html: string) => {

    state._content = html
}
setTimeout(() => {
    state.disabled = true
}, 2000)

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_quill_editor = _resolveComponent("quill-editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Editor",
      mains: "Simple Editor",
      title: "Simple Editor"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card3), {
          colClass: "col-sm-12",
          title: "Simple Editor",
          headerTitle: "true",
          cardhaderClass: "card-no-border pb-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_quill_editor, {
              value: state.content,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.content) = $event)),
              options: state.editorOption,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (onEditorChange($event)))
            }, null, 8, ["value", "options"])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})